<template>
    <div id="main">
    <div id="mapContainer">
      <Filters :selectedFilters="selectedFilters"
      @toggle-filter="toggleFilter"/>
      <Map :activeMarkers="activeMarkers"/>
      <IncidentCounter :activeMarkers="activeMarkers" />
    </div>
    <Footer
      @search="search"
    />
    </div>
</template>

<script>
import * as L from 'leaflet';
import Vue from 'vue';
import Map from './Map.vue';
import Filters from './Filters.vue';
import IncidentCounter from './IncidentCounter.vue';
import Overlay from './Overlay.vue';
import Footer from './Footer.vue';

const markerData = require('../data/data.json');

export default {
  name: 'Main',
  components: {
    Map,
    Filters,
    IncidentCounter,
    Footer,
  },
  methods: {
    initializeMarkers() {
      const OverlayConstructor = Vue.extend(Overlay);
      markerData.forEach((entry) => {
        const raid = entry.affiliation;
        const marker = L.marker([
          entry.lat,
          entry.lng,
        ], {});
        const data = {
          name: entry.person,
          location: entry.location,
          agency: entry.targeter,
          outcome: entry.nature_of_targeting,
          narrative: entry.short_narrative,
          media: entry.media,
          sources: entry.sources,
        };
        const overlay = new OverlayConstructor({
          propsData: data,
        });
        overlay.$mount();
        marker.bindPopup(overlay.$el.innerHTML);
        marker.filters = [];
        const targetingFilters = entry.nature_of_targeting.split(';');
        targetingFilters.forEach((filter) => marker.filters.push(filter.trim()));
        const agencyFilters = entry.targeter.split(';');
        agencyFilters.forEach((filter) => marker.filters.push(filter.trim()));
        marker.person = entry.person;
        marker.raidClass = raid;
        this.markers.push(marker);
      });
    },
    toggleFilter(option) {
      const index = this.selectedFilters.indexOf(option);
      if (index === -1) {
        this.selectedFilters.push(option);
      } else {
        this.selectedFilters.splice(index, 1);
      }
    },
    search(searchTerm) {
      this.activeSearchTerm = searchTerm;
    },
  },
  computed: {
    activeMarkers() {
      if ((this.selectedFilters && this.selectedFilters.length > 0) || this.activeSearchTerm) {
        const activeMarkers = [];
        this.markers.forEach((marker) => {
          if (this.selectedFilters.some((f) => marker.filters.includes(f))) {
            activeMarkers.push(marker);
          } else if (marker.person.toLowerCase().includes(this.activeSearchTerm.toLowerCase())) {
            if (this.activeSearchTerm !== '') activeMarkers.push(marker);
          }
        });
        return activeMarkers;
      }
      return this.markers;
    },
  },
  data() {
    const selectedFilters = [];
    const markers = [];
    const activeSearchTerm = '';
    return {
      selectedFilters,
      markers,
      activeSearchTerm,
    };
  },
  mounted() {
    this.initializeMarkers();
  },
};
</script>

<style>
.leaflet-layer:first-of-type {
  /* filter: invert(100%)
  invert(9%) sepia(8%) saturate(4814%) hue-rotate(176deg) brightness(88%) contrast(86%); */
  filter: grayscale(100%) sepia(38%) hue-rotate(350deg) invert(100%) brightness(150%);
}
#mapContainer {
  position: absolute;
  top: 0px;
  bottom: 72px;
  left: 0;
  right: 0;
}
.leaflet-control-zoom-in,
.leaflet-control-zoom-out {
  font-size: 30px !important;
  width: 40px !important;
  height: 40px !important;
  line-height: 35px !important;
}
@media screen and (max-width: 1000px) {
  #mapContainer {
    top: 0;
    bottom: 0;
  }
}
@media screen and (max-width: 700px) {
  .leaflet-control-zoom-in, .leaflet-control-zoom-out { display: none !important; }
}
</style>
